import { getRoot } from "mobx-easy";
import { MeteogramVariables } from "../enum/EnvironmentalType";
import { Units } from "../stores/data/unitMeasurement/UnitMeasurementStore";
import RootStore from "../stores/root-store";

type UseConvertValueToUserUnitProps = {
  value?: number;
  environmentalVariable?: string;
  defaultUnit?: string;
};

export default function useConvertValueToUserUnit({
  value,
  defaultUnit,
  environmentalVariable,
}: UseConvertValueToUserUnitProps) {
  const {
    dataStores: { unitMeasurementStore },
  } = getRoot<RootStore>();

  const getUnitUser = (environmentalVariable: string) => {
    const unitMeasurementConfig = unitMeasurementStore.getUnitMeasurementConfig(
      environmentalVariable as MeteogramVariables
    );

    if (unitMeasurementConfig) {
      return unitMeasurementConfig;
    }

    return null;
  };

  const unitsUser = getUnitUser(environmentalVariable as string);

  const convertToUserUnit = (val: number) => {
    if (!defaultUnit || val === undefined || val === null) return null;

    return unitMeasurementStore.convertUnit(
      val,
      defaultUnit.toLowerCase() as Units,
      unitsUser as Units
    );
  };

  const unit = value !== undefined ? convertToUserUnit(value) : null;

  return {
    unit,
    unitsUser,
    convertToUserUnit,
    getUnitUser,
  };
}
